import { createSlice } from "@reduxjs/toolkit";
export const MyProfileSubscriptionSlice = createSlice({
  name: "MyProfileSubscription",
  initialState: {
    MySubscriptionPlanId: "",
    MySubscriptionPlanName: "",
    MySubscriptionPlan: "",
  },
  reducers: {
    getMySubscriptionPlanId: (state, action) => {
      state.MySubscriptionPlanId = action.payload;
    },
    getMySubscriptionPlanName: (state, action) => {
      state.MySubscriptionPlanName = action.payload;
    },
    getMySubscriptionPlan: (state, action) => {
      state.MySubscriptionPlan = action.payload;
    },
  },
});
export const {
  getMySubscriptionPlanId,
  getMySubscriptionPlanName,
  getMySubscriptionPlan,
} = MyProfileSubscriptionSlice.actions;
export default MyProfileSubscriptionSlice.reducer;
